module.exports = __webpack_public_path__ + "static/media/wings.5f96e48a.png";